module.exports = __webpack_public_path__ + "static/media/PM130.f87a29a3.png";